import { FormDialog } from "components/dialogs/Dialogs";
import ExpectedCargosForm from "view/cargos/components/createEdit/ExpectedCargosForm";
import { useForm } from "react-hook-form";
import { ExpectedCargo } from "view/cargos/types/cargo";
import { gql } from "__generated__/gql";
import { useMutation } from "@apollo/client";
import { Language } from "utils";

const ExpectedCargosCreateEditDialog = ({ callId, callExpectedCargos, open, onClose, refetch }: {
	callId: number,
	callExpectedCargos: ExpectedCargo[],
	open: boolean,
	onClose: () => void,
	refetch: () => void,
}) => {

	const { control, formState, watch, handleSubmit } = useForm({
		defaultValues: {
			expectedCargos: callExpectedCargos,
		},
	});

	const [ save, { loading } ] = useMutation(SAVE_EXPECTED_CARGOS);

	const onSave = (data: { expectedCargos: ExpectedCargo[] }) => {
		if (data.expectedCargos.some(expectedCargo => !expectedCargo.containerType?.isoTypeCode)) {
			return;
		}

		save({
			variables: {
				callId: callId,
				inputs: data.expectedCargos.map(expectedCargo => ({
					...expectedCargo,
					amount: Number(expectedCargo.amount),
					dischargingLocationId: expectedCargo.dischargingLocation?.id,
					callId: callId,
					containerTypeCode: expectedCargo.containerType!.isoTypeCode,
					containerType: undefined,
					dischargingLocation: undefined,
				})),
			},
		}).then(() => {
			onClose();
			refetch();
		});
	};

	const expectedCargos = watch("expectedCargos");

	return (
		<FormDialog
			open={open}
			onClose={onClose}
			loading={loading}
			form="expected-cargos-form"
			title={Language("EXPECTED_CONTAINERS")}
			maxWidth="md"
			dialogStyling={{ content: { padding: "unset" } }}
		>
			<form onSubmit={handleSubmit(onSave)} id="expected-cargos-form">
				<ExpectedCargosForm
					control={control}
					formState={formState}
					expectedCargos={expectedCargos}
					nameBase="expectedCargos"
				/>
			</form>
		</FormDialog>
	);
};

const SAVE_EXPECTED_CARGOS = gql(`#graphql
	mutation saveExpectedCargos($callId: Long!, $inputs: [ExpectedCargoInput!]!) {
		saveExpectedCargos(callId: $callId, inputs: $inputs) {
			id
		}
	}
`);

export default ExpectedCargosCreateEditDialog;
